const CLARITY_PROJECT_ID = 'vuhajb26w8';
const CLARITY_SCRIPT_ID = 'yk-clarity-script';

export function ensureClarityLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (document.getElementById(CLARITY_SCRIPT_ID)) return;

  window.clarity =
    window.clarity ||
    function() {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const script = document.createElement('script');
  script.id = CLARITY_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  script.dataset.ykClarity = 'true';

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
}